import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { getEscalatedTickets } from "../../../services/supportApi";
import { differenceInMinutes, parseISO } from "date-fns";

const TicketList = () => {
  const navigate = useNavigate();
  const [page] = useState(1);
  const [status, setStatus] = useState("pending_midoffice");

  const { data, isLoading, isError } = useQuery({
    queryKey: ["support-tickets", status, page],
    queryFn: () => getEscalatedTickets(status, page, 20),
  });

  const tickets = data?.data?.tickets || [];

  return (
    <div className="ticket-list">
      <h2>Mid-Office Support Tickets</h2>
      <div className="tabs">
        <button
          className={status === "pending_midoffice" ? "active" : ""}
          onClick={() => setStatus("pending_midoffice")}
        >
          Unassigned
        </button>
        <button
          className={status === "assigned_midoffice" ? "active" : ""}
          onClick={() => setStatus("assigned_midoffice")}
        >
          My Tickets
        </button>
      </div>

      {isLoading && <p>Loading tickets...</p>}
      {isError && <p>Error loading tickets.</p>}

      {!isLoading && !isError && tickets.length === 0 && (
        <p>No tickets found.</p>
      )}

      {!isLoading && !isError && tickets.length > 0 && (
        <table className="ticket-table">
          <thead>
            <tr>
              <th>Ticket ID</th>
              <th>Customer</th>
              <th>Priority</th>
              <th>Status</th>
              <th>SLA</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map((ticket) => {
              const assignedAt = ticket.midOfficeAssignedAt
                ? parseISO(ticket.midOfficeAssignedAt)
                : new Date();
              const minutesElapsed = differenceInMinutes(
                new Date(),
                assignedAt,
              );
              const minutesLeft = 30 - minutesElapsed;
              const isUrgent = minutesLeft < 5;

              return (
                <tr key={ticket._id || ticket.ticketId}>
                  <td>{ticket.ticketId}</td>
                  <td>{ticket.customerName || "N/A"}</td>
                  <td>{ticket.priority || "Normal"}</td>
                  <td>{ticket.status}</td>
                  <td className={isUrgent ? "urgent-sla" : ""}>
                    {minutesLeft > 0 ? `${minutesLeft} mins left` : "Overdue"}
                  </td>
                  <td>
                    <button
                      onClick={() =>
                        navigate(`/MOD/complaints/support/${ticket.ticketId}`)
                      }
                    >
                      View
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TicketList;
